export * from "@vaadin/details/vaadin-details-summary.js";
export * from './generated/DetailsSummary.js';
